import { getConfigFromStorage } from '@/utils/config';
import axios, { InternalAxiosRequestConfig } from 'axios';

// intercepting when there is client_id
axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const configStorage = getConfigFromStorage();

  config.headers['client-id'] = configStorage?.client_id || '';
  return config;
});
